import { FC } from "react";
import styles from "./Form.module.scss";

interface Props {
    setAll(): void;
}

const FormSelect: FC<Props> = ({ setAll }) => {
    return (
        <div className={styles.selectAll}>
            <span>Tracked transactions</span>
            <button onClick={setAll} type="button" className={styles.select}>
                Select all
            </button>
        </div>
    );
};

export default FormSelect;
